'use client'

import Image from 'next/image'

const LIFESTYLE_ITEMS = [
  {
    src: '/images/petselect/lifestyle/happy-dog.jpg',
    alt: 'Happy golden retriever outdoors',
    caption: 'Active & Healthy',
    span: 'md:col-span-2 md:row-span-2',
    aspect: 'aspect-square',
  },
  {
    src: '/images/petselect/lifestyle/curious-cat.jpg',
    alt: 'Cat relaxing on couch',
    caption: 'Comfort & Care',
    span: '',
    aspect: 'aspect-square',
  },
  {
    src: '/images/petselect/lifestyle/bird-perch.jpg',
    alt: 'Dog with toy',
    caption: 'Play & Joy',
    span: '',
    aspect: 'aspect-square',
  },
  {
    src: '/images/petselect/lifestyle/fish-aquarium.jpg',
    alt: 'Cat eating premium food',
    caption: 'Premium Nutrition',
    span: 'md:col-span-2',
    aspect: 'aspect-[2/1]',
  },
]

export function PetSelectLifestyle() {
  return (
    <section className="py-14 md:py-18 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <p className="text-[#0B7A75] text-xs font-semibold tracking-widest uppercase mb-2">Lifestyle</p>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
            Happy Pets, Happy Life
          </h2>
          <p className="text-gray-400 text-sm max-w-md mx-auto">
            We believe every pet deserves the best. From nutrition to playtime, we&apos;ve got you covered.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {LIFESTYLE_ITEMS.map((item) => (
            <div
              key={item.alt}
              className={`relative overflow-hidden rounded-xl group ${item.span} ${item.aspect}`}
            >
              <Image
                src={item.src}
                alt={item.alt}
                fill
                sizes="(max-width: 768px) 50vw, 33vw"
                className="object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
              <p className="absolute bottom-3 left-3 text-white text-xs font-semibold tracking-wide">
                {item.caption}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
